export default __webpack_public_path__ + "static/media/2.28cde32f.jpg";